import { useRef, useState } from "react"
import toast from "react-hot-toast"
import type { SuccessFetch } from "types"
import type { UploadType } from "../../types"
import { useApi } from "utils"

export function useHandleFile(): {
  handleFileCancel: () => void
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSaveFileExcel: () => Promise<UploadType>
  ref: React.MutableRefObject<HTMLInputElement | null>
  selectedFile: File | null
} {
  // Hooks
  const api = useApi()
  const ref = useRef<HTMLInputElement | null>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  // Functions
  const handleFileCancel = (): void => {
    setSelectedFile(null)

    if (ref.current) {
      ref.current.value = ""
    }
  }
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
  
    if (file) {
      const reader = new FileReader()
      setSelectedFile(file)

      // reader.onload = (e) => {
      //   const binaryStr = e.target?.result as string
      //   const workbook = read(binaryStr, { type: "binary" })
      //   const sheetName = workbook.SheetNames[0]
      //   const sheet = workbook.Sheets[sheetName]
      //   const jsonData = utils.sheet_to_json(sheet, { header: 1 })
  
      //   const headers = jsonData[1] as string[]
      //   const hasProductBuy = headers.includes("ACC_BUY_NAME")
      //   const hasProductInv = headers.includes("NO_ACC_INVENTORY")
      //   const hasProductSell = headers.includes("NO_ACC_SELL")
  
      //   if (!hasProductBuy || !hasProductInv || !hasProductSell) {
      //     toast.error("File format is not correct!")
      //     handleFileCancel()
      //     return
      //   }
      // }

      reader.readAsBinaryString(file)
    }
  }
  const handleSaveFileExcel = (): Promise<UploadType> => {
    return new Promise<UploadType>((resolve) => {
      
      if (!selectedFile) {
        toast.error("File not selected!")
        return
      }
  
      const formData = new FormData()
      formData.append("ExcelFile", selectedFile)
  
      toast.promise(
        api.post("/import_coa/importexcel", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      ).then((res: SuccessFetch<{
        payload: UploadType
      }>) => {
        resolve(res.data.payload)
      }).catch(() => {
        handleFileCancel()

        resolve({
          data: [],
          identity_batch: ""
        })
      })
    })
  }

  return {
    ref,
    selectedFile,
    handleFileCancel,
    handleFileChange,
    handleSaveFileExcel
  }
}